module.exports = __webpack_public_path__ + "static/mujeres003.thumb-cd73095a39c58917aa9c0b968679afdf.jpg";